// removed by extract-text-webpack-plugin
module.exports = {"root":"_108qLm4A0GQgUj9ABW7Ml_"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true,"publicPath":"/"}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"id":"data-v-7de08e05","scoped":false,"hasInlineConfig":false}!./~/gotu-vue-dycolor/dist/lib/dycolor-loader.js!./~/sass-loader/lib/loader.js?{"sourceMap":true}!./src/gotu-vue-common/src/components/timeline/events/comment/Comment.scss
// module id = 996
// module chunks = 1